import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class TotalJobsSetToInvoiceReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            url:'/api/v1/portal/portal-admin/total_jobs_set_to_invoice_report/',
            downloadUrl:'/api/v1/portal/portal-admin/download-total_jobs_set_to_invoice_report/',
            totalUsers:[],
            selectedStartDate:moment().toDate(),
            selectedEndDate:moment().toDate(),
            filename:'Total Jobs Approved And Set To Invoice',
            isDownloading:false,
            totalJobs:0
        };
        this.handleselectedStartDateChange = this.handleselectedStartDateChange.bind(this);
        this.handleselectedEndDateChange = this.handleselectedEndDateChange.bind(this);
    }
    handleselectedStartDateChange(date) {
        this.setState({selectedStartDate: date})
    }
    handleselectedEndDateChange(date) {
        this.setState({selectedEndDate: date})
    }
    handleTotalJobsSetToInvoiceReport(e) {
        this.setState({isLoading: true});
        let url = this.state.url+moment(this.state.selectedStartDate).format("YYYY-MM-DD")+'/'+moment(this.state.selectedEndDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              this.setState({
                totalUsers: response.users,
                isLoading: false
              })
            });
          }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }

    downloadableCsvDataTotalJobsRaisedByUser(){
        this.setState({isDownloading: true});
        let url = this.state.downloadUrl+moment(this.state.selectedStartDate).format("YYYY-MM-DD")+'/'+moment(this.state.selectedEndDate).format("YYYY-MM-DD");
        let csvFileName = this.state.filename+' From '+moment(this.state.selectedStartDate).format("DD_MM_YYYY")+' To '+moment(this.state.selectedEndDate).format("DD_MM_YYYY")+'.xlsx';
        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then(response => response.blob())
            .then(blob => {
                this.setState({isDownloading: false});
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = csvFileName;
                document.body.appendChild(a); 
                a.click();    
                a.remove(); 
            }).catch(err=>{
            alert('sorry something went wrong.') ;
        }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }
    render() {
        let totalUsers = [];
        let totalJobs = this.state.totalJobs;
        let tableHeaders = [];

        let downloadableCsvDataApproved = "";

        if(this.state.totalUsers.length > 0){
            let headers = this.state.totalUsers[0];
            Object.keys(headers).forEach(function(key) {
                if(key == 'userid'){
                    return;
                }else if(key == 'full_name'){
                    tableHeaders.push(<th>USER</th>);
                }else{
                    tableHeaders.push(<th>{moment(key).format('DD/MM/YYYY')}</th>);
                } 
            });
            totalUsers = this.state.totalUsers.map(crow =>{
                return (
                    <tr key={crow.userID}>
                        {Object.keys(crow).filter(k => k !== 'userid').map(k => {
                            if(k == 'userid'){
                                return;
                            }else{
                                return (
                                    <td key={crow.userID+'-'+k}>{crow[k]}</td>
                                );
                            }
                        })}
                    </tr>
                );
            });
            let lastRow = this.state.totalUsers.slice(-1).pop();
            Object.keys(lastRow).forEach(function(key) {
                if(key == 'full_name'){return;}
                totalJobs += (!lastRow[key]) ? 0 : parseInt(lastRow[key]);
            });
        }else{
            totalUsers.push(
               <tr key='no-records'><td colSpan="4" className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Total Jobs Set To Invoice Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-1">
                        From Date:
                    </div>
                    <div className="col-md-1">
                        To Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-1">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleselectedStartDateChange} selected={this.state.selectedStartDate}/>
                    </div>
                    <div className="col-md-1">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleselectedEndDateChange} selected={this.state.selectedEndDate}/>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsSetToInvoiceReport(e)}>
                                <i className="fa fa-download"></i> Generate Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvDataTotalJobsRaisedByUser(e)}}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <h4 className="alert alert-info">Total Jobs set to invoice for the day from {moment(this.state.selectedStartDate).format("DD/MM/YYYY")} to {moment(this.state.selectedEndDate).format("DD/MM/YYYY")} are : <b>{totalJobs}</b></h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                   <tr>{tableHeaders}</tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="4"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totalUsers}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-total_jobs_set_to_invoice_report')) {
    ReactDOM.render(
        <TotalJobsSetToInvoiceReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-total_jobs_set_to_invoice_report')
    );
}
